import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=48fa760a&scoped=true&"
import script from "./BankAccountList.vue?vue&type=script&lang=js&"
export * from "./BankAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa760a",
  null
  
)

export default component.exports